import { useContext } from "react";
import "./style.css";
import HeaderName from "../../components/HeaderName";
import { useTranslation } from "react-i18next";
import ActionBtn from "@/components/ActionBtn";
import { useNavigate } from "react-router-dom";
import { PrivilegeContext } from "@/context/PrivilegesContext";
import { CRRender } from "@/components/crRender";
import HomeProvider from "./HomeProvider";
import Stats from "./components/Stats";
import ChartsContainer from "./components/ChartsContainer";

 const HomePage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { userRoleId } = useContext(PrivilegeContext);

 


  return (
    <HomeProvider>
      <div className="home-page">
        <HeaderName PageName={t("Home")} />
      {/* <Stats /> */}

       {/* <ChartsContainer /> */}
      <CRRender isRender={userRoleId == 4}>
        <ActionBtn
          className="submit-btn"
          title="edit-profile"
          onApply={() => navigate("/panel/provider-profile")}
        />
      </CRRender>
      </div>
    </HomeProvider>
  );
};


export default HomePage;
